import environments from './contracts/lib/environments.json';

module.exports = environments;



// WEBPACK FOOTER //
// src/index.js